// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"375":"25e92088","484":"2de29ef3","629":"2d5f16fc","828":"5a1f7ca5"}[chunkId] + ".chunk.js";
};